import React, {useCallback, useState} from "react"
import {useForm} from "react-hook-form";
import * as yup from 'yup'
import {Box, Button, TextField} from "@material-ui/core";

const validationSchema = yup.object().shape({
  email: yup.string().required().email(),
  password: yup.string().required().max(32)
});

export interface LoginFormData {
  email: string
  password: string
}

type LoginFormProps = {
  onSubmit: (data: LoginFormData) => Promise<void>
}

export const LoginForm = (p: LoginFormProps) => {
  const {register, handleSubmit, errors} = useForm<LoginFormData>({validationSchema}),
    [disabled, setDisabled] = useState(false);

  const onSubmit = useCallback(async (data: LoginFormData) => {
    setDisabled(true);
    try {
      await p.onSubmit({ ...data, email: data.email.toLocaleLowerCase() })
    } finally {
      setDisabled(false)
    }
  }, [p]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextField
        inputRef={register}
        disabled={disabled}
        error={!!errors.email}
        helperText={errors.email?.message}
        name='email'
        label='Email'
        margin='dense'
        fullWidth
        variant='outlined' />
      <TextField
        inputRef={register}
        disabled={disabled}
        type='password'
        error={!!errors.password}
        helperText={errors.password?.message}
        name='password'
        label='Password'
        margin='dense'
        fullWidth
        variant='outlined' />
      <Box mt={2}/>
      <Button disabled={disabled} variant='contained' type='submit' fullWidth color='primary'>
        Login
      </Button>
    </form>
  )
};

